import FormularioUsuarios from '../../components/users/FormularioUsuarios';
import { useTituloCabecera } from '../../context/tituloCabeceraContext';

const ListadoUsuarios = () => {
  useTituloCabecera('Alumnos', 'Gestiona y busca alumnos del sistema');
  return <FormularioUsuarios />;
};

export default ListadoUsuarios;
